import { render, staticRenderFns } from "./VContextInfo.vue?vue&type=template&id=53b3436b&scoped=true&"
import script from "./VContextInfo.vue?vue&type=script&lang=ts&"
export * from "./VContextInfo.vue?vue&type=script&lang=ts&"
import style0 from "./VContextInfo.vue?vue&type=style&index=0&id=53b3436b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b3436b",
  null
  
)

export default component.exports